import { useEffect } from "react";
import carrierOils from ".././files/carrier_oils.json";
import { useLocation } from "react-router-dom";
import { addDefaultImg } from "../components/imageUtils";

function LogisticsTesting() {
  useEffect(() => {
    document.title = "Logistic & Testing Facility - Deww Botanicals";
  }, []);


  // Check if the URL contains a specific word
  const location = useLocation();
  const shouldShowElement = location.pathname.includes("logistic_support");

  const videoSrc = shouldShowElement
    ? "../assets/logistics.mp4"
    : "../assets/testing.mp4";

  return (
    <>
      {/* // Page Header Start */}
      <div className="container-fluid page-header position-relative banner_video overflow-hidden">
        <video
          key={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          className="position-absolute w-100 h-100 object-fit-cover"
          style={{ top: 0, left: 0, zIndex: -1 }}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">
            {shouldShowElement ? "Logistics Support" : "Testing Facilities"}
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <span className="text-body">Home</span>
              </li>
              <li
                className="breadcrumb-item text-dark active"
                aria-current="page"
              >
                {shouldShowElement ? "Logistics Support" : "Testing Facilities"}
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* // Page Header End */}

      {shouldShowElement ? (
        <div className="container-xxl py-3 container-fluid p-0 mb-5 wow fadeIn">
          <div className="container">
            <div className="row my-3">
              <div className="col-12 col-md-9 m-auto">
                <p>
                  At Deww Botanicals, we recognize that prompt and secure
                  delivery of your orders is just as important as the quality of
                  our products. That's why we have established strong
                  partnerships with leading, globally recognized shipping and
                  logistics companies. Our goal is to provide a seamless and
                  efficient shipping experience that reflects the premium
                  quality of our essential oils, carrier oils, spice oils,
                  natural butters, floral waters, and liquid extracts.
                </p>

                <h4>Global Reach with a Local Touch</h4>
                <p>
                  No matter where you are in the world, Deww Botanicals ensures
                  that your products are delivered to you promptly and in
                  perfect condition. We cater to a broad network of customers
                  across continents, including small-scale retailers and
                  large-scale industrial buyers. Our global shipping
                  infrastructure is designed to overcome geographical boundaries
                  while upholding the highest standards of service.
                </p>
                <h4>Safety is Our Priority</h4>
                <p>
                  We prioritize the safety and integrity of every shipment. Each
                  order is carefully packaged using high- quality, eco-friendly
                  materials that maintain the freshness, purity, and therapeutic
                  properties of our products during transit. If any damage
                  occurs during transportation, we take full responsibility and
                  ensure a quick resolution or replacement. Your peace of mind
                  is our commitment.
                </p>
                <h4>Flexible Shipping Options to Suit Your Needs</h4>
                <p>
                  We provide a wide range of shipping methods to meet your
                  needs:
                </p>
                <ul>
                  <li>
                    <strong>Air Freight:</strong> Best for urgent orders that require quick
                    delivery.
                  </li>
                  <li>
                    <strong>Sea Freight:</strong> Ideal for large shipments, offering a
                    cost-effective logistics solution.
                  </li>
                  <li>
                    <strong>Road Transport:</strong> Suitable for domestic or regional
                    deliveries, ensuring efficient doorstep service.
                  </li>
                </ul>
                <p>
                  Our clients can choose the shipping method that best fits
                  their timeline, budget, and location. Whether you're placing a
                  large international order or a single domestic shipment, we
                  customize our delivery approach to meet your expectations.
                </p>
                <h4>Punctual, Transparent, and Trackable Deliveries</h4>
                <p>
                  We are committed to keeping you informed throughout the entire
                  process. All shipments are trackable, and our customer service
                  team is always available to provide real-time updates, address
                  any questions, and coordinate with couriers for seamless
                  delivery. Our goal is to deliver not only your order but also
                  peace of mind and trust in our service.
                </p>
                <h4>Customized Logistics Support for B2B Clients</h4>
                <p>
                  For wholesale and B2B customers, Deww Botanicals provides
                  customized logistics support, including documentation, freight
                  insurance, and adherence to international trade regulations.
                  Our team of export and shipping specialists collaborates
                  closely with yours to ensure that all paperwork and
                  certifications are in order, minimizing the risk of delays or
                  complications at customs.
                </p>
                <p>
                  At Deww Botanicals, delivery is not just the conclusion of a
                  transaction; it is a continuation of our commitment to serving
                  you with excellence. No matter where you are or what you
                  order, you can trust us to deliver not only products but also
                  satisfaction, security, and exceptional service—on time, every
                  time.
                </p>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-md-9 m-auto">
                <div className="row align-items-center mb-4">
                  <div className="col-4">
                    <div className="img-wrap">
                      <img
                        className="w-100 rounded"
                        src="../assets/images/air_logistics.jpg"
                        onError={addDefaultImg}
                        alt="NA"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="img-wrap">
                      <img
                        className="w-100 rounded"
                        src="../assets/images/water_logistics.jpg"
                        onError={addDefaultImg}
                        alt="NA"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="img-wrap">
                      <img
                        className="w-100 rounded"
                        src="../assets/images/road_logistics.jpg"
                        onError={addDefaultImg}
                        alt="NA"
                      />
                    </div>
                  </div>
                </div>
                <h4>Key Highlights of Our Shipping Services :</h4>

                <ul>
                  <li>
                    <strong>Global Reach : </strong>We provide reliable shipping services to
                    customers worldwide, ensuring our high-quality oils reach
                    you efficiently.
                  </li>
                  <li>
                    <strong>Priority on Safety : </strong>The safety and integrity of your order
                    are our top priorities. We take full responsibility for any
                    damage incurred to the material before it arrives at your
                    doorstep.
                  </li>
                  <li>
                    <strong>Multiple Delivery Options : </strong>Choose from air, water, or road
                    transport for fast and flexible delivery solutions tailored
                    to your location and requirements.
                  </li>
                </ul>

                <p>
                  Our commitment to exceptional service means you can trust us
                  to deliver your products securely and on time, every time.
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-xxl py-3 container-fluid p-0 mb-5 wow fadeIn">
          <div className="container">
            <div className="row my-3">
              <div className="col-12 col-md-9 m-auto">
                <h3>Our Commitment to Quality Assurance and Documentation</h3>
                <p className="mt-2">
                  At Deww Botanicals, we view quality as more than just a
                  standard; it's a promise we uphold at every step of our
                  process. We rigorously control quality from the sourcing of
                  raw materials to the final stages of packaging and shipment.
                  Our protocols ensure that every product meets and exceeds both
                  national and international industry standards.
                </p>

                <h4>100% Tested, Certified & Traceable</h4>
                <p>
                  Every batch of material that leaves our facility undergoes
                  thorough testing and verification to ensure its purity,
                  potency, and safety. We collaborate with accredited
                  laboratories and our internal quality experts to perform
                  extensive testing and analysis, ensuring that our customers
                  receive only the highest quality botanicals.
                </p>
                <h4>Comprehensive Documentation Provided</h4>
                <p>
                  To ensure complete transparency and foster lasting trust with
                  our clients, we provide a comprehensive set of quality and
                  safety documents with every order. These documents not only
                  verify the integrity of the product but also help demonstrate
                  compliance with local and international regulatory standards.
                </p>
                <h4>Our standard documentation includes:</h4>
                <p>
                  <strong>Certificate of Analysis (COA): </strong>Verifies the product's
                  physical, chemical, and microbial properties, confirming that
                  it meets specified quality standards
                </p>
                <p>
                  <strong>Material Safety Data Sheet (MSDS): </strong>Provides detailed
                  information on handling, storage, potential hazards, and first
                  aid measures related to the product.
                </p>
                <p>
                  <strong>Gas Chromatography-Mass Spectrometry (GC-MS) Report: </strong>Offers a
                  detailed breakdown of the chemical composition, ensuring
                  authenticity and helping to identify any adulteration or
                  contamination.
                </p>
                <p>
                  <strong>Non-Dangerous Goods (NON-DG) Certification: </strong>Confirms that the
                  material is safe for shipping under standard non-hazardous
                  goods regulations, facilitating international logistics.
                </p>
                <p>
                  <strong>Additional Documentation (available on request): </strong>Includes
                  organic certificates, allergen statements, heavy metal
                  reports, pesticide residue analyses, and more, depending on
                  your specific requirements or the regulations of the
                  destination country.
                </p>
                <h4>Traceability and Batch Control</h4>
                <p>
                  All our products come with clear batch numbers and
                  traceability documentation, enabling our customers to track
                  the origin and testing history of the materials they receive.
                  This level of detail ensures consistent quality, regulatory
                  compliance, and peace of mind for our partners and clients.
                </p>
                <p>
                  When you choose Deww Botanicals, you're not just purchasing
                  botanical products; you're investing in trusted quality,
                  safety, and comprehensive documentation.
                </p>
                <p>
                  Our commitment to excellence gives your business the
                  confidence to create superior end products for your customers.
                </p>

                {/* <ul>
                  <li>Certificate of Analysis (COA)</li>
                  <li>Material Safety Data Sheet (MSDS)</li>
                  <li>Gas Chromatography-Mass Spectrometry (GC-MS) Report</li>
                  <li>Non-Dangerous Goods (NON-DG) Certification</li>
                  <li>Additional Required Documentation</li>
                </ul> */}
              </div>
            </div>
            <div className="row my-3">
              <div className="col-12 col-md-9 m-auto">
                <div className="row align-items-center">
                  <div className="col-4">
                    <div className="img-wrap">
                      <img
                        className="w-100 rounded"
                        src="../assets/images/lab-testing.jpg"
                        onError={addDefaultImg}
                        alt="NA"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="img-wrap">
                      <img
                        className="w-100 rounded"
                        src="../assets/images/gcms.jpg"
                        onError={addDefaultImg}
                        alt="NA"
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="img-wrap">
                      <img
                        className="w-100 rounded"
                        src="../assets/images/hplc.jpg"
                        onError={addDefaultImg}
                        alt="NA"
                      />
                    </div>
                  </div>
                </div>
                <p className="my-3">
                  We are dedicated to 100% client satisfaction and believe in
                  full transparency. To uphold these standards, we have
                  partnered with government-recognized third-party testing labs
                  for accurate and reliable results. Our commitment is to
                  deliver excellence with every product, backed by thorough
                  documentation and trusted testing.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default LogisticsTesting;
